import React from 'react';
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./App.css";

const ContactUs = () => {
  return (
    <div
      style={{
        backgroundColor: "#000",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        color: "white",
      }}
    >
      <Header showDiscoverBtn={true} />
      <div
        style={{
          flex: 1,
          color: "white",
          width: "90%",
          maxWidth: "800px",
          margin: "30px auto",
          padding: "0 15px",
          fontFamily: "Montserrat, sans-serif",
          lineHeight: "1.6",
        }}
      >
        <p>Hello and welcome!</p>
        <p>
          Thank you for choosing Vibe Stream. It honestly means a lot that you found your way here. We created Vibe Stream to remove the clutter and clickbait that gets in the way of enjoying music videos everyday.
        </p>
        <p>
          If you're using Vibe Stream and have any questions or suggestions, please contact me via email: zach[@]vibe-stream.tv and you will be responded to within 24 hours.
        </p>
        <p>
          All music videos are licensed. If you would like to reach us regarding
          licensing or have a DMCA related request please email: support [@]
          vibe-stream.tv
        </p>
        <p>Much Love,</p>
        <p>Vibe Stream</p>
        <p>@vibes.are.free</p>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;
